// extracted by mini-css-extract-plugin
export default {"RegisterDetails":"RegisterDetails_RegisterDetails__5G9Fm","Header":"RegisterDetails_Header__rFrHD","User":"RegisterDetails_User__ZdJ9i"};